export enum Environment {
  Development = 'Development',
  Production = 'Production',
}
